// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app[data-v-343354f4]{display:flex;flex-direction:column;min-height:100vh}.container[data-v-343354f4]{margin-top:200px;margin-bottom:100px;flex-grow:1}h1[data-v-343354f4]{margin-bottom:10px}.text[data-v-343354f4]{margin-bottom:70px}", ""]);
// Exports
module.exports = exports;
